import {
  FaCcAmex,
  FaCcDinersClub,
  FaCcDiscover,
  FaCcJcb,
  FaCcMastercard,
  FaCcVisa,
  FaRegCreditCard,
} from 'react-icons/fa';

import { CardBrand } from '~/types';

export const getCardIcon = (cardBrand: CardBrand) => {
  return {
    unknown: FaRegCreditCard,
    amex: FaCcAmex,
    diners: FaCcDinersClub,
    discover: FaCcDiscover,
    jcb: FaCcJcb,
    mastercard: FaCcMastercard,
    unionpay: FaRegCreditCard,
    visa: FaCcVisa,
  }[cardBrand];
};
